<div class="choices-answer">
  <app-radio-button *ngFor="let choice of question.answer_choices" class="choices-answer__control">
    <input type="radio" [value]="choice.id" name="choices-answer" />
    <radio-button-text>{{ choice.text }}</radio-button-text>
  </app-radio-button>
</div>
